import React from 'react'
import Filterbox from '../components/filterbox'
import Womens from '../components/Women'
import '../cssfiles/panel.css'
function panel2() {
  return (
    <div className='home'>
    <div className='home_panellist-wrap'>
        <div className='home_panel_wrap'>
            <Filterbox />
        </div>

        <div className='home_list_wrap'>
            <Womens />
        </div>
    </div></div>
  )
}

export default panel2